import { frontendURL } from '../../../helper/URLHelper';
import AiChatLayout from './components/AiChatLayout.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-chat'),
    component: AiChatLayout,
    name: 'ai_chat_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/ai-chat/:agentId'),
    component: AiChatLayout,
    name: 'ai_chat_agent',
    meta,
    props: true,
  },
  {
    path: frontendURL(
      'accounts/:accountId/ai-chat/:agentId/conversations/:conversationId'
    ),
    component: AiChatLayout,
    name: 'ai_chat_conversation',
    meta,
    props: true,
  },
];

export default { routes };
